import { Alert, Grid, Stack } from "@mui/material";
import ScrollableFlexContainer from "@entrilia/shared/components/ScrollableFlexContainer";
import type { IrrDrillDownInfo } from "../../../../../../../../../api/types/svTypes.ts";
import useDrillDown from "../../../../../hooks/useDrillDown";
import type { DrillDownPage } from "../../../../../store/types/drillDownPageState.types";
import CollapseContainer from "../../../../common/CollapseContainer";
import ConditionsCollapsedHeader from "../ConditionsCollapsedHeader";
import ReadonlyConditions from "../ReadonlyConditions";
import { CashFlowGrid } from "./CashFlowGrid";
import ToolBar from "./ToolBar";
import { stopEventPropagation } from "../../../../../utilities/stopEventPropagation.ts";

export interface Props {
  configuration: DrillDownPage;
  info: IrrDrillDownInfo;
}

export default function CashFlowPart({ configuration, info }: Props) {
  const state = useDrillDown(info);

  return (
    <Grid container sx={{ position: "relative", width: "100%", height: "100%" }}>
      <CollapseContainer
        collapseElement={<ConditionsCollapsedHeader conditionsCount={state.conditions.length} />}
        containerSx={{
          height: "100%",
          ".MuiCollapse-root": {
            height: "100%",
          },
          borderRight: "1px solid",
          borderColor: "divider",
          minHeight: 0,
        }}
      >
        <ReadonlyConditions
          state={state}
          configuration={configuration}
          info={info}
          containerSx={{ width: 340, p: "1.3rem", pl: 3 }}
        />
      </CollapseContainer>
      <Stack sx={{ flex: 1, width: "unset" }}>
        <Stack spacing={2} useFlexGap sx={{ flex: 1, width: "unset", pl: "1.3rem", py: 2, pr: 3 }}>
          <ToolBar configuration={configuration} info={info} />
          {state.error && (
            <Alert sx={{ mb: ".5rem" }} severity="error">
              {state.error}
            </Alert>
          )}
          <ScrollableFlexContainer scrollContainerSx={{ mb: 1 }} onDrop={stopEventPropagation}>
            <CashFlowGrid configuration={configuration} info={info} />
          </ScrollableFlexContainer>
        </Stack>
      </Stack>
    </Grid>
  );
}
